export default function Blog() {
  return (
    <div className="blog">
    </div>
  );
}
